import { DONATE_TO_CHARITY_REQUEST, DONATE_TO_CHARITY_SUCCESS, DONATE_TO_CHARITY_ERROR } from '../constants/ActionTypes'
import type GenericAction from './types/genericAction.types'

export type DonateToCharityAction = GenericAction<
    typeof DONATE_TO_CHARITY_REQUEST | typeof DONATE_TO_CHARITY_SUCCESS | typeof DONATE_TO_CHARITY_ERROR,
    { error?: { errorKey: string } }
>

type State = {
    loading: boolean
    error: { body: { error: { errorKey: string } } } | null
}

const initialState: State = {
    loading: false,
    error: null,
}

const donateToCharity = (state = initialState, action: DonateToCharityAction) => {
    switch (action.type) {
        case DONATE_TO_CHARITY_REQUEST: {
            return { ...state, loading: true, error: null }
        }
        case DONATE_TO_CHARITY_SUCCESS: {
            return { ...state, loading: false }
        }
        case DONATE_TO_CHARITY_ERROR:
            return { ...state, loading: false, error: { body: { error: action.error } } }
        default:
            return state
    }
}

export default donateToCharity
